export function alertObject(obj: any) {
    alert(JSON.stringify(obj, null, 2))
}
